import { useT } from "@/lib/i18n";

const ITEMS = ["Volkswagen", "Audi", "BMW", "Mercedes-Benz", "Volvo", "Toyota", "Ford", "Škoda", "Porsche", "Land Rover", "Peugeot", "Nissan"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center">
        <span className="px-8 font-display text-5xl font-black uppercase italic tracking-tight text-zinc-200 md:text-7xl">{t}</span>
        <span className="h-3 w-3 rotate-45 bg-[var(--red)]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const t = useT({ no: "Vi jobber med de fleste bilmerker", en: "We work with most car brands" });
  return (
  <section data-testid="brand-marquee" className="relative overflow-hidden border-y border-white/10 bg-[var(--surface)] py-8">
    <div className="mb-4 px-5 text-center font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-400">
      {t}
    </div>
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
  );
};
